import * as Sentry from "@sentry/react";
import React, { Component, ErrorInfo, ReactNode } from "react";
import { Button } from "./ui/button";
import { RefreshCcw } from "lucide-react";

interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        Sentry.captureException(error, { 
            tags: { area: "system", crash: "true" },
            extra: { ...errorInfo } 
        });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-background p-4">
                    <div className="text-center space-y-4 max-w-md">
                        <h2 className="text-2xl font-bold">Algo salió mal</h2>
                        <p className="text-muted-foreground">
                            La aplicación ha encontrado un error inesperado. Por favor, intenta recargar la página.
                        </p>
                        <Button
                            onClick={() => window.location.reload()}
                            className="gradient-primary font-bold rounded-xl"
                        >
                            <RefreshCcw className="mr-2 h-4 w-4" />
                            Recargar Aplicación
                        </Button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
